import { useEffect } from "react";
import { withRouter } from "react-router";
import { useSelector } from "react-redux";

function LogoutBase(props) {
  const { config } = useSelector((state) => state.global);

  useEffect(() => {
    if (config.unsubscribe) {
      config.unsubscribe();
    }

    config.userHelper.logout(
      () => {
        // props.history.push(props.routes.login.path);
        window.location.assign("/login");
      },
      (error) => {
        window.location.assign("/");
      }
    );
  }, [config]);

  return null;
}

export default LogoutBase;
